//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/Builder.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"CurrentSelectedPort",1,"TaggedObject",0],[1,"RunItems",0,"SelectNXObjectList",0],[0,"VirtualReferenceId",1,0]],[[["scopedObject","referenceId","portName","availablePorts"],"SetSelectedItemData",{},4,0],[["virtualReferenceId"],"GetVirtualStubItem",{R_:{virtualStubItem:"TaggedObject"}},1,0]],[]];
SPLM.Routing.RunItemsBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.RunItemsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;